import { render, staticRenderFns } from "./EyebrowUserInfo.vue?vue&type=template&id=52167a15&shadow"
import script from "./EyebrowUserInfo.vue?vue&type=script&lang=js&shadow"
export * from "./EyebrowUserInfo.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./EyebrowUserInfo.vue?vue&type=style&index=0&lang=scss&module=true&shadow")
if (style0.__inject__) style0.__inject__(context)
this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports